import { render, staticRenderFns } from "./AzSocietiesReadOnly.vue?vue&type=template&id=dea8b38a"
import script from "./AzSocietiesReadOnly.vue?vue&type=script&lang=js"
export * from "./AzSocietiesReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports